module.exports = __webpack_public_path__ + "img/bf_m.1ce92539.jpg";